import React from 'react';

import { RisksIcon } from '@/components/icons';
import { getRiskSeverityIcon } from '@/components/icons/RiskSeverity.icon';
import { Tooltip } from '@/components/Tooltip';
import { PartialAsset } from '@/hooks/useAssets';
import { RiskSeverity, SeverityDef } from '@/types';

export function RiskSummary(asset: {
  riskSummary: PartialAsset['riskSummary'];
}) {
  if (
    !asset.riskSummary ||
    !Object.values(asset.riskSummary).find(noOfRisk => noOfRisk)
  ) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={
        <div className="flex flex-col gap-2">
          {Object.entries(asset.riskSummary)
            .filter(riskSeverity => {
              const noOfRisks = riskSeverity[1];

              return noOfRisks > 0;
            })
            .map((riskSeverity, index) => {
              const severity = riskSeverity[0] as RiskSeverity;
              const noOfRisks = riskSeverity[1];

              const severityIcon = getRiskSeverityIcon(
                severity as RiskSeverity,
                'size-5'
              );

              return (
                <div key={index} className="flex items-center">
                  {severityIcon}
                  <div className="pr-1 pl-2">{noOfRisks}</div>
                  {SeverityDef[severity]}
                </div>
              );
            })}
        </div>
      }
    >
      <div className="mr-1">
        <RisksIcon className="text-chariot-stroke-critical size-4" />
      </div>
    </Tooltip>
  );
}
